module.exports = __webpack_public_path__ + "img/inklogo.07586d26.png";